import { Injectable, signal } from '@angular/core';

/**
 * Small shared state holder for the vendor shell's off-canvas drawer.
 *
 * The vendor shell OWNS the drawer's open/closed state; the topbar hamburger
 * toggles it and the sidebar (or a backdrop click / ESC) closes it. Keeping the
 * flag in a root-provided service — rather than threading @Input/@Output through
 * the shell → topbar / sidebar tree — lets any shell child read or mutate it
 * without a chain of bindings.
 *
 * Persistent-rail mode (>=900px) simply ignores this flag (the sidebar is always
 * in flow); it only drives the slide-in panel + backdrop at <=900px.
 */
@Injectable({ providedIn: 'root' })
export class ShellNavService {
  /** Whether the off-canvas drawer is currently open (only meaningful <=900px). */
  readonly drawerOpen = signal(false);

  toggle(): void {
    this.drawerOpen.update((open) => !open);
  }

  open(): void {
    this.drawerOpen.set(true);
  }

  close(): void {
    this.drawerOpen.set(false);
  }
}
